import { PromoInterface } from '../../../../../common/types/interfaces'
import { Item } from '../item/Item'
import classes from './List.module.sass'

type Props = {
  startEdit: (el: PromoInterface) => void
  startMailing: (el: PromoInterface) => void
  showDetails: (el: PromoInterface) => void
  list: PromoInterface[] | []
  loading: boolean
}

export const List = ({ startEdit, list, showDetails, loading, startMailing }: Props) => {
  return (
    <div className={classes.container}>
      {!list?.length && !loading ? (
        <div className={classes.Message}>Нет промо акций</div>
      ) : (
        list.map((el) => (
          <Item
            showDetails={showDetails}
            el={el}
            startEdit={startEdit}
            key={el.id}
            startMailing={startMailing}
          />
        ))
      )}
    </div>
  )
}
